/** Cifras operativas de la tienda (ajustar cuando el catálogo real esté en línea). */
export const storeMetrics = {
  referenciasInventario: 863,
  marcasDistribuidas: 11,
  horasSurtidoCdmx: 48,
  kitsDesdeMxn: 9800,
  instalacionesRegistradas: 2847,
  aniosOperacion: 32,
} as const;

export const metricCards = [
  {
    value: String(storeMetrics.referenciasInventario),
    label: 'referencias surtibles',
  },
  {
    value: String(storeMetrics.marcasDistribuidas),
    label: 'marcas en catálogo',
  },
  {
    value: `${storeMetrics.horasSurtidoCdmx} hrs`,
    label: 'surtido CDMX y área metropolitana',
  },
  {
    value: 'CFDI 4.0',
    label: 'factura en el mismo pedido',
  },
] as const;

export const trustLine = [
  `${storeMetrics.referenciasInventario} referencias`,
  `${storeMetrics.marcasDistribuidas} marcas`,
  `${storeMetrics.horasSurtidoCdmx} hrs surtido CDMX`,
  'CFDI en checkout',
] as const;
